/**
 * Formata um porquê estruturado ({numero, pergunta, resposta}) numa string
 * "Por que X? Porque Y." sem duplicar prefixos ("Por que" / "Porque") quando a
 * IA já os incluiu, e sem duplicar pontuação terminal ("?" / ".").
 *
 * Usado na renderização dos porquês da Hipótese Alternativa, que chegam ao
 * frontend como objetos estruturados (não pré-formatados pelo backend, ao
 * contrário de `cinco_porques`).
 *
 * Simetria com o backend `ai_service._map_v4_to_legacy` / `reanalisar_parcial_6m`
 * (fix TD-140). Extraído para util compartilhado (Sessão 18): antes existia
 * só em ReportPrintable.jsx; ReportV2.jsx concatenava sem guard e regredia o
 * bug "Por que Por que X?? Porque Porque Y".
 */
export function formatHipoteseAlternativaPorque(p) {
  if (typeof p !== 'object' || p === null) {
    return p;
  }
  const perguntaRaw = (p.pergunta || '').toString().trim();
  const respostaRaw = (p.resposta || '').toString().trim();

  // Guard de prefixo: só adiciona "Por que"/"Porque" se não veio da IA.
  const pergPrefixed =
    !perguntaRaw.toLowerCase().startsWith('por que') &&
    !perguntaRaw.toLowerCase().startsWith('por quê')
      ? `Por que ${perguntaRaw}`
      : perguntaRaw;
  const respPrefixed =
    !respostaRaw.toLowerCase().startsWith('porque') &&
    !respostaRaw.toLowerCase().startsWith('por que')
      ? `Porque ${respostaRaw}`
      : respostaRaw;

  // Strip pontuação terminal pra não duplicar quando o concat adiciona "?" e ".".
  const perg = pergPrefixed.replace(/[?.]+\s*$/, '').trim();
  const resp = respPrefixed.replace(/[?.]+\s*$/, '').trim();

  return `${perg}? ${resp}.`;
}

export default formatHipoteseAlternativaPorque;
